import {ProgressCircle} from '@github-ui/progress-circle'
import {TriangleRightIcon} from '@primer/octicons-react'
import type {TokenProps} from '@primer/react'
import {Token} from '@primer/react'
import {clsx} from 'clsx'

import styles from './SubIssuesSummaryToken.module.css'

interface Progress {
  total: number
  completed: number
  percentCompleted: number
}

export interface SubIssueCompletionTokenProps extends Omit<TokenProps, 'leadingVisual' | 'text' | 'ref'> {
  progress: Progress
}

export function SubIssuesSummaryToken({
  progress: {total, completed, percentCompleted},
  className,
  ...tokenProps
}: SubIssueCompletionTokenProps) {
  const expandOnHover = (tokenProps.as === 'button' && !tokenProps.disabled) || tokenProps.as === 'a'
  const visualLabel = `${completed} / ${total}`
  const accessibleLabel = `${completed} of ${total} ${total === 1 ? 'issue' : 'issues'} completed`

  return (
    <Token
      leadingVisual={() => <ProgressCircle percentCompleted={percentCompleted} size={14} />}
      text={
        <>
          <span aria-hidden="true">{visualLabel}</span>
          <span className="sr-only">{accessibleLabel}</span>
          {expandOnHover && (
            /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
            <TriangleRightIcon className={clsx('triangle', styles.expandTriangleIcon)} />
          )}
        </>
      }
      {...tokenProps}
      className={clsx(styles.SubIssuesSummaryToken, className)}
    />
  )
}
